/**
 * Copyright (c) 2017 CRF Box Oy. All Rights Reserved. Company Confidential.
 */

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ReportsModalContainer from '../studies/reports/reports.modal.container';
import SponsorsModal from '../sponsors/sponsors.modal.container';
import HelpdeskModal from '../helpdesk/helpdesk.modal.container';
import CModalWindow from '../common/modal/modalWindow.component.container';
import {
  MODAL_TYPE_SPONSORS,
  MODAL_TYPE_HELPDESK,
  MODAL_TYPE_EDIT_PARTICIPANT_STATUS,
  MODAL_TYPE_EDIT_PARTICIPANT_DETAILS,
  MODAL_TYPE_EDIT_PARTICIPANT_GENDER,
  MODAL_TYPE_EDIT_PARTICIPANT_BIRTHDATE,
  MODAL_TYPE_EDIT_PARTICIPANT_ADDRESS,
  MODAL_TYPE_EDIT_DOCUMENT_STATUS,
  MODAL_TYPE_ADD_NOTE,
  MODAL_TYPE_PDF_MODAL,
  MODAL_TYPE_ALL_SITES_REPORTS,
  MODAL_TYPE_FLAG,
  MODAL_TYPE_WAITING,
  MODAL_TYPE_DELETE_PDF,
  MODAL_TYPE_DELETE_ADDENDUM,
  MODAL_TYPE_ADD_NEW_PARTICIPANT_DOCUMENT,
  MODAL_TYPE_PARTICIPANT_HAS_NEW_VERSIONS,
  MODAL_TYPE_EDIT_PARTICIPANT_EMAIL,
  MODAL_TYPE_REMOVE_OBJECT_ID,
  MODAL_TYPE_UPDATE_OBJECT_ID,
  MODAL_TYPE_PARTICIPANT_ARCHIVE,
  MODAL_TYPE_PARTICIPANT_ARCHIVE_EXPORT,
  MODAL_TYPE_ARCHIVE_EXPORT_CONFIRMATION,
  MODAL_TYPE_EDIT_DOCUMENT_STATUS_OPT_INOUT,
  MODAL_TYPE_CHANGE_ANSWERS,
  MODAL_TYPE_CHANGE_ANSWERS_OPTIN_OPTOUT,
  MODAL_TYPE_CHANGE_ANSWERS_ADDENDUM
} from '../../constants/modalTypes';

import PdfModalContainer from '../documents/pdf.modal.container';
import ModalAddNote from '../notes/add.note.modal';
import DocumentStatusModal from '../document_status/document.status.modal';
import DocumentStatusOptInOptOutModal from '../document_status/optinoptout/document.status.optinoptout.modal';
import ParticipantStatusModal from '../participants/participant.status.modal';
import ParticipantEmailModal from '../participants/participant.email.modal';
import ParticipantDetailsChangeModal from '../subject/participant.details.change.modal';
import FlagContainer from '../consentingJournal/flag.container';
import WaitingModal from '../documents/waiting.modal';
import AddDocumentModal from '../documents/add.new.participant.document.modal';
import DeleteDocumentModal from '../documents/delete.document.modal';
import DeleteAddendumModal from '../documents/delete.addendum.modal';
import ParticipantHasNewVersionsModal from '../participants/participant.has.new.versions.modal.container';
import { RemoveBiosampleCodeModal, UpdateBiosampleCodeModal } from '../responses/modals';
import ParticipantGenderModalContainer from '../participants/participant.gender.modal.container';
import ParticipantBirthdateModalContainer from '../participants/participant.birthdate.modal.container';
import ParticipantAddressModalContainer from '../participants/participant.address.modal.container';
import ParticipantArchiveModalContainer from '../studies/reports/participant-archive.modal.container';
import ParticipantArchiveExportModalContainer from '../studies/reports/participant-archive-export.modal.container';
import ConfirmationArchiveExportModalContainer from '../studies/reports/confirmation-archive-export.modal.container';
import ChangeAnswersDateReasonModal from '../change_answers/change.answers.date_reason.modal';
import ChangeAnswersOptInOptOutModal from '../change_answers/change.answers.optinoptout.modal';
import ChangeAnswersAddendumModal from '../change_answers/change.answers.addendum.modal';

const MODAL_COMPONENTS = {
  [MODAL_TYPE_SPONSORS]: SponsorsModal,
  [MODAL_TYPE_HELPDESK]: HelpdeskModal,
  [MODAL_TYPE_EDIT_PARTICIPANT_STATUS]: ParticipantStatusModal,
  [MODAL_TYPE_EDIT_PARTICIPANT_DETAILS]: ParticipantDetailsChangeModal,
  [MODAL_TYPE_EDIT_PARTICIPANT_GENDER]: ParticipantGenderModalContainer,
  [MODAL_TYPE_EDIT_PARTICIPANT_BIRTHDATE]: ParticipantBirthdateModalContainer,
  [MODAL_TYPE_EDIT_PARTICIPANT_ADDRESS]: ParticipantAddressModalContainer,
  [MODAL_TYPE_EDIT_DOCUMENT_STATUS]: DocumentStatusModal,
  [MODAL_TYPE_EDIT_DOCUMENT_STATUS_OPT_INOUT]: DocumentStatusOptInOptOutModal,
  [MODAL_TYPE_ADD_NOTE]: ModalAddNote,
  [MODAL_TYPE_PDF_MODAL]: PdfModalContainer,
  [MODAL_TYPE_ALL_SITES_REPORTS]: ReportsModalContainer,
  [MODAL_TYPE_PARTICIPANT_ARCHIVE]: ParticipantArchiveModalContainer,
  [MODAL_TYPE_PARTICIPANT_ARCHIVE_EXPORT]: ParticipantArchiveExportModalContainer,
  [MODAL_TYPE_ARCHIVE_EXPORT_CONFIRMATION]: ConfirmationArchiveExportModalContainer,
  [MODAL_TYPE_FLAG]: FlagContainer,
  [MODAL_TYPE_WAITING]: WaitingModal,
  [MODAL_TYPE_DELETE_PDF]: DeleteDocumentModal,
  [MODAL_TYPE_DELETE_ADDENDUM]: DeleteAddendumModal,
  [MODAL_TYPE_ADD_NEW_PARTICIPANT_DOCUMENT]: AddDocumentModal,
  [MODAL_TYPE_PARTICIPANT_HAS_NEW_VERSIONS]: ParticipantHasNewVersionsModal,
  [MODAL_TYPE_EDIT_PARTICIPANT_EMAIL]: ParticipantEmailModal,
  [MODAL_TYPE_REMOVE_OBJECT_ID]: RemoveBiosampleCodeModal,
  [MODAL_TYPE_UPDATE_OBJECT_ID]: UpdateBiosampleCodeModal,
  [MODAL_TYPE_CHANGE_ANSWERS]: ChangeAnswersDateReasonModal,
  [MODAL_TYPE_CHANGE_ANSWERS_OPTIN_OPTOUT]: ChangeAnswersOptInOptOutModal,
  [MODAL_TYPE_CHANGE_ANSWERS_ADDENDUM]: ChangeAnswersAddendumModal
};

class ModalRoot extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    const { type, props } = this.props;

    if (!type) {
      return null;
    }

    let ModalComponent = MODAL_COMPONENTS[type];
    return (
      <CModalWindow>
        <ModalComponent {...props} />
      </CModalWindow>
    );
  }
}

ModalRoot.propTypes = {
  type: PropTypes.string,
  props: PropTypes.object
};

export default ModalRoot;
